export { default } from "./CurricSEOAccordion";
